import React from "react";
import {
  Button,
  PanelDialog,
  PanelHeading,
  PanelRow,
  PanelSpacer,
  PanelActions,
  BoldText,
} from "@backslashbuild/pp-ui";
import { usePost } from "./api";
import { publish } from "../../pubSub";
import { useHistory } from "react-router-dom";

function CancelPayRunButton({ id }) {
  const history = useHistory();

  // you have to query to see if there are any currently staged pay runs and then disable the button.
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const cancelPayRun = usePost("payruns/cancel");

  async function handleSubmit() {
    try {
      const response = await cancelPayRun({ payRunId: id });

      if (response.isSuccess) {
        publish("notification", "Pay Run Cancelled");
        history.push(`/payruns`);
      } else {
        publish(
          "notification",
          <>
            Unable to cancel pay run
            <ul>
              {response.errors.map((error) => (
                <li>{error}</li>
              ))}
            </ul>
          </>
        );
      }
    } catch (e) {
      console.error(e, "error cancelling pay run");
      publish("notification", "A network error occured.");
    }
  }

  return (
    <>
      <Button variant="secondary" onClick={() => setDialogOpen(true)}>
        Cancel pay run
      </Button>
      <PanelDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <PanelHeading>Cancel Pay Run</PanelHeading>
        <PanelSpacer large />
        <PanelRow>
          <BoldText>
            Are you sure you want to cancel this pay run?
            <br />
            All payslips will be cancelled and the requests-for-processing will be unlocked.
          </BoldText>
        </PanelRow>
        <PanelSpacer large />
        <PanelActions>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            No, Don't cancel
          </Button>
          <Button onClick={handleSubmit}>Yes, cancel pay run</Button>
        </PanelActions>
        <PanelSpacer large />
      </PanelDialog>
    </>
  );
}

export default CancelPayRunButton;
